import styled from "styled-components";
import ClearIcon from "@mui/icons-material/Clear";
import FilterListOutlinedIcon from "@mui/icons-material/FilterListOutlined";
import { colors } from "healthex-common/colors";
import { fontSizes } from "healthex-common/sizes";
import { fontWeights } from "healthex-common/weights";
import { HXTextField } from "./base.styles";
import { FlexColumnDiv, FlexRowDiv } from "./common.styles";
export const SearchModalContent = styled(FlexColumnDiv) `
    gap: 16px;
    height: 100%;
    min-height: 0;
    overflow: hidden;

    @media (max-width: 480px) {
        flex: 1;
    }
`;
export const SearchInputRow = styled(FlexRowDiv) `
    width: 100%;
    gap: 8px;
    align-items: center;
`;
export const SearchInputContainer = styled(FlexRowDiv) `
    width: 100%;
    flex: 1;
`;
export const FilterToggleButton = styled.button `
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 8px;
    border: 1px solid ${(props) => (props.$active ? colors.navy_main : colors.black_12)};
    background-color: ${(props) => (props.$active ? colors.navy_4 : "transparent")};
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;

    &:hover {
        background-color: ${colors.navy_4};
        border-color: ${colors.navy_main};
    }
`;
export const FilterIcon = styled(FilterListOutlinedIcon) `
    font-size: 24px !important;
    color: ${colors.navy_main};
`;
export const FilterPanel = styled(FlexColumnDiv) `
    padding: 16px;
    border-radius: 12px;
    border: 1px solid ${colors.black_12};
    background-color: ${colors.white_main};
    gap: 16px;
`;
export const FilterSection = styled(FlexColumnDiv) `
    gap: 8px;
`;
export const FilterSectionTitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const FilterLabel = styled.div `
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_main};
`;
export const ZipcodeInput = styled(HXTextField) `
    width: 100%;
`;
export const StyledSearchInput = styled(HXTextField) `
    width: 100%;
`;
export const ScrollableContent = styled(FlexColumnDiv) `
    gap: 16px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
`;
export const SearchInfoHeader = styled(FlexRowDiv) `
    padding: 12px 0;
    font-size: ${fontSizes.SMALL};
    font-weight: ${fontWeights.NORMAL};
    color: ${colors.black_lighter};
    align-items: flex-start;
    gap: 8px;
    flex-shrink: 0;
    line-height: 1.5;

    svg {
        margin-top: 3px;
        flex-shrink: 0;
    }
`;
export const SearchResultsList = styled(FlexColumnDiv) `
    gap: 8px;
`;
export const SearchResultItem = styled(FlexRowDiv) `
    padding: 12px 16px;
    border-radius: 8px;
    border: 1px solid ${colors.black_12};
    cursor: pointer;
    transition: all 0.15s ease;
    align-items: center;
    gap: 12px;

    &:hover {
        background-color: ${colors.navy_4};
        border-color: ${colors.navy_main};
    }
`;
export const ResultIcon = styled.div `
    width: 40px;
    height: 40px;
    border-radius: 8px;
    background-color: ${colors.navy_8};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.navy_main};
    font-weight: ${fontWeights.SEMI_BOLD};
    font-size: ${fontSizes.SMALL};
    flex-shrink: 0;
`;
export const ResultLogo = styled.img `
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: contain;
    flex-shrink: 0;
    background-color: ${colors.white_main};
`;
export const ResultDetails = styled(FlexColumnDiv) `
    flex: 1;
    gap: 2px;
`;
export const ResultTitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const ResultSubtitle = styled.div `
    font-size: ${fontSizes.SMALL};
    color: ${colors.black_lighter};
`;
export const NoResultsMessage = styled.div `
    text-align: center;
    padding: 32px;
    color: ${colors.black_lighter};
    font-size: ${fontSizes.STANDARD};
`;
export const ClearSearchIcon = styled(ClearIcon) `
    font-size: 20px !important;
    color: ${colors.black_lighter};
`;
export const ModalFooter = styled.div `
    margin-top: auto;
    padding-top: 16px;
    text-align: center;
    font-size: ${fontSizes.MICRO};
    color: ${colors.black_lighter};
    line-height: 1.5;
    flex-shrink: 0;
`;
export const FooterLink = styled.a `
    color: ${colors.black_lighter};
    text-decoration: underline;
    cursor: pointer;

    &:hover {
        color: ${colors.black_main};
    }
`;
export const LoadMoreIndicator = styled.div `
    height: 1px;
    width: 100%;
`;
export const LoadMoreSpinnerContainer = styled.div `
    display: flex;
    justify-content: center;
    padding: 16px 0;
`;
export const PortalSelectionContent = styled(FlexColumnDiv) `
    gap: 16px;
    height: 100%;
    min-height: 0;
    overflow: hidden;

    @media (max-width: 480px) {
        flex: 1;
    }
`;
export const PortalList = styled(FlexColumnDiv) `
    gap: 8px;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
`;
export const PortalSelectionFooter = styled.div `
    margin-top: auto;
    padding: 24px 0;
    flex-shrink: 0;
    display: flex;
    justify-content: center;

    > button {
        min-width: 50%;
    }
`;
export const PortalItem = styled(FlexRowDiv) `
    padding: 16px;
    border-radius: 8px;
    border: 1px solid ${colors.black_12};
    cursor: pointer;
    transition: all 0.15s ease;
    align-items: center;
    justify-content: space-between;

    &:hover {
        background-color: ${colors.navy_4};
        border-color: ${colors.navy_main};
    }
`;
export const PortalInfo = styled(FlexColumnDiv) `
    gap: 4px;
`;
export const PortalName = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const PortalWebsite = styled.div `
    font-size: ${fontSizes.SMALL};
    color: ${colors.black_lighter};
`;
export const SuggestionsSectionTitle = styled.div `
    font-size: ${fontSizes.STANDARD};
    font-weight: ${fontWeights.SEMI_BOLD};
    color: ${colors.black_main};
`;
export const SuggestionLetterAvatar = styled.div `
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: ${colors.navy_8};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${colors.navy_main};
    font-weight: ${fontWeights.SEMI_BOLD};
    font-size: ${fontSizes.STANDARD};
    flex-shrink: 0;
`;
